import { useState, useEffect } from "react";
import JsxParser from 'react-jsx-parser';
import ManagerNav from "./managernav";
import StaffNav from "../staff/staffnav";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";

export default function CourseViewer() {
  const [trainingDocuments, setTrainingDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [documentsPerPage] = useState(1); // Number of documents per page (adjust this value)
  const [pagesViewed, setPagesViewed] = useState(0); // Track how many pages have been viewed

  const token = localStorage.getItem('token');

    const location = useLocation();

    const user = useContext(AuthContext); // Access the user state from AuthContext

    console.log(location.state.courseDocName)

    const courseDocName = location.state.courseDocName;


  useEffect(() => {
    const fetchTrainingDocuments = async () => {

      console.log(courseDocName)

      try {
        const response = await fetch(`https://api.insightos.co.uk/api/courseviewer/${courseDocName}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',

          },
          credentials : 'include',

        });

        if (response.ok) {
          const data = await response.json();
          console.log(data.data)
          const sortedDocuments = data.data.sort((a, b) => a.Page - b.Page); // Sort documents by page
          setTrainingDocuments(sortedDocuments);
        } else {
          console.error('Failed to fetch training documents');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchTrainingDocuments();
  }, [courseDocName]);

  // Get the documents for the current page
  const indexOfLastDocument = currentPage * documentsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentsPerPage;
  const currentDocuments = trainingDocuments.slice(indexOfFirstDocument, indexOfLastDocument);

  // Handle Next button click
  const nextPage = () => {
    if (currentPage < Math.ceil(trainingDocuments.length / documentsPerPage)) {
      setCurrentPage(currentPage + 1);
      setPagesViewed(pagesViewed + 1); // Increment pages viewed
    }
  };

  // Handle Previous button click
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setPagesViewed(pagesViewed - 1); // Decrement pages viewed
    }
  };

  // Calculate progress percentage
  const progressPercentage = (currentPage / Math.ceil(trainingDocuments.length / documentsPerPage)) * 100;

  return (
   <>
         {(user.access === 'admin' || user.access === 'manager') ? (
              <ManagerNav />   
            ) : (
              <StaffNav />
            )}

        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            
        <div className="w-full max-w-full min-h-screen p-8 border rounded-lg bg-white shadow-lg overflow-auto">
       
        <div className="flex flex-col items-center justify-center flex-grow overflow-y-auto">
          <div className="w-full">
            {currentDocuments.map((doc, index) => (
              <div key={index} className="w-full mb-1">
                <JsxParser components={{}} jsx={doc.Code} />
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <button
            onClick={prevPage}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Previous
          </button>
          <button
            onClick={nextPage}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Next
          </button>
        </div>

        {/* Display progress */}
        <div className="mt-4 text-center">
          <p className="text-sm font-medium">Progress: {Math.min(progressPercentage, 100).toFixed(2)}%</p>
          <p className="text-xs text-gray-500">Pages Viewed: {pagesViewed} out of {Math.ceil(trainingDocuments.length / documentsPerPage)}</p>
        </div>
        {/* Pagination Controls */}
        
      </div>
    </div>
    </>
  );
}
